import React, { useState, useEffect } from 'react'
import "./footer.css"
import styled from "styled-components"
import Loadable from "@loadable/component"
import { uhfFooterData } from "../../testData/uhfFooter";
import PhoenixUtil from '../PhoenixUtilities/utilities';


const UniversalFooter = Loadable(() =>
  import("@airasia/phoenix-widgets/widgets/UniversalFooter")
)

const getUhfData = async (lang = "en-gb", isChinaDomain=false) => {
  let footerPath = "universalfooter";
  if(isChinaDomain){ // https://static.airasia.com/cosmos/uhf/universalfootercn/en-gb/file.json
    footerPath = "universalfootercn";
  }
  let reqRes = await fetch(["dev", "stg"].includes(process.env.GATSBY_ENV) ? `https://static.stgairasia.com/cosmos/uhf/${footerPath}/${lang}/file.json` : `https://static.airasia.com/cosmos/uhf/${footerPath}/${lang}/file.json`);
  let responseData = await reqRes.json();
  return responseData;
}


var Connect = styled.div`
 @media screen and (min-width:1024px){
    display: flex;
    flex: 1 1 0%;
    flex-flow: row wrap;
    -webkit-box-pack: end;
    justify-content: flex-end;
  }

`

var AboveFooterDiv = styled.div`
@media screen and (max-width:768px){
  display:none;
}
`


export default function Footer(props) {

  const [dataUHF, setDataUHF] = useState(uhfFooterData);

  useEffect(() => {
    if (typeof (window) !== "undefined") {
      let isChinaDomain = PhoenixUtil.isChinaDomainName();
      getUhfData(props?.locale || "en-gb", isChinaDomain).then(res => {
        setDataUHF(res)
      });
    }
  }, [])


  return (
    <div className="footer">
      <div className="connect" style={{ borderTop: "1px solid rgb(217, 219, 224)" }}>
        <div className="containers">
          <AboveFooterDiv className="top">
            <div className="container">
              <div className="row">
                <div className="col-sm-3">
                  <h5>Travel Information</h5>
                  <ul>
                  </ul>
                  <ul>
                    <li><a href="https://support.airasia.com/s/article/Airports-and-Terminals?language=en_GB" target="TRUE">Airports and terminals</a></li>
                    <li><a href="https://support.airasia.com/s/topic/0TO7F000000TQXtWAO/baggage?language=en_GB" target="TRUE">Baggage</a></li>
                    <li><a href="https://support.airasia.com/s/article/What-is-Self-Check-In-en?language=en_GB" target="TRUE">Check-in information</a></li>
                    {/* <li><a href="https://www.airasia.com/my/en/about-us/customer-service-and-contingency-plan.page" target="TRUE">Customer service and tarmac delay contingency plan</a></li> */}
                    <li><a href="https://www.airasia.com/my/en/book-with-us/our-fares.page" target="TRUE">Our fares</a></li>
                    <li><a href="https://www.airasia.com/flightstatus/en/GB" target="TRUE">Flight status</a></li>
                    <li><a href="https://www.airasia.com/my/en/inflight-comforts/hot-meals.page" target="TRUE">Inflight meals</a></li>
                    <li><a href="https://www.airasia.com/my/en/inflight-comforts/entertainment.page" target="TRUE">Inflight entertainment</a></li>
                    <li><a href="https://www.airasia.com/my/en/book-with-us/payment-channels.page" target="TRUE">Payment channels</a></li>
                    <li><a href="https://www.airasia.com/my/en/inflight-comforts/seat-options.page" target="TRUE">Seat options</a></li>
                    <li><a href="https://taxinvoice.airasia.com/" target="TRUE">Tax invoice</a></li>
                    <li><a href="https://www.airasia.com/aa/about-us/en/gb/fees-and-charges.html" target="TRUE">Fees and Charges</a></li>
                  </ul>
                </div>
                <div className="col-sm-3">
                  <h5>Our Products and Services</h5>
                  <ul>
                  </ul>
                  <ul>
                    <li><a href="https://www.airasia.com/deals/en/gb" target="TRUE">AirAsia Unlimited Deals</a></li>
                    <li><a href="https://ikhlas.com/en/" target="TRUE">Ikhlas</a></li>
                    <li><a href="https://airasiaredtix.com/" target="TRUE">AirAsia RedTix</a></li>
                    <li><a href="https://www.airasia.com/flights/" target="TRUE">Cheap flights</a></li>
                    <li><a href="https://www.airasia.com/my/en/inflight-comforts/duty-free-and-merchandise.page" target="TRUE">Duty free and merchandise</a></li>
                    <li><a href="https://www.airasia.com/my/en/at-the-airport/red-carpet.page" target="TRUE">Red Carpet</a></li>
                    <li><a href="https://premiumup.airasia.com/d7/standbys/up" target="TRUE">Premium Up</a></li>
                    <li><a href="https://www.airasiabig.com/my/en/big-membership?utm_campaign=NA_ALL_MMBS_None_None&utm_medium=referral&utm_source=aa_SEO_flights_footer#freedomflyerprogramme" target="TRUE">Freedom Flyer Programme</a></li>
                    <li><a href="https://www.airasiabig.com/my/en/big-membership?utm_campaign=NA_ALL_MMBS_None_None&utm_medium=referral&utm_source=aa_SEO_flights_footer#waystoearn" target="TRUE">BIG Points</a></li>
                    <li><a href="https://bigxchange.airasiabig.com/?utm_source=aa_SEO_flights_footer&utm_medium=referral&utm_campaign=bx&langCode=en-gb" target="TRUE">BIG Xchange</a></li>
                    <li><a href="https://www.airasia.com/aa/about-us/en/gb/agent-signup.html" target="TRUE">Register as an agent</a></li>
                    <li><a href="https://www.airasia.com/agent/login/en/gb" target="TRUE">Agent login</a></li>
                    <li><a href="https://docs.google.com/forms/d/e/1FAIpQLScy9UGyXoFQ_UIwQxGJaMNxqowTGEJhH0HO6UDeARJjyK70tg/viewform" target="TRUE">Charter</a></li>
                    <li><a href="https://www.airasia.com/aa/inflight-comforts/en/gb/ecatalog.html" target="TRUE">Download e-catalog</a></li>
                  </ul>
                </div>
                <div className="col-sm-3">
                  <h5>Partners' Product</h5>
                  <ul>
                  </ul>
                  <ul>
                    <li><a href="https://my.trip.com/airasia/airport-transfers/index?s=car_back&channelid=235307&allianceid=1249677&sid=3043440&locale=en_my" target="TRUE">Airport Transfers</a></li>
                    <li><a href="https://my.trip.com/airasia/cars?channelid=17401&allianceid=1245342&sid=2998374&locale=en_my" target="TRUE">Car Rental</a></li>
                    <li><a href="https://www.airasiacards.com" target="TRUE">airasia Card</a></li>
                    <li><a href="https://disclaimer.airasia.com/?language=en&amp;redirect_to=https://system.bellugg.com/Booking/AirAsia" target="TRUE">Luggage delivery</a></li>
                    <li><a href="https://www.bigpayme.com/" target="TRUE">BigPay</a></li>
                    <li><a href="https://www.cimbbank.com.my/en/personal/products/accounts/savings-accounts/airasia-savers-account.html" target="TRUE">CIMB Savers</a></li>
                    <li><a href="https://www.tuneprotect.com/airasia/en/home/" target="TRUE">AirAsia Travel Protection</a></li>
                    <li><a href="https://www.airasia.com/--/online-delivery-santan/en/gb" target="TRUE">Santan ASEAN Restaurant</a></li>
                  </ul>
                </div>
                <div className="col-sm-3">
                  <h5>About Us</h5>
                  <ul>
                  </ul>
                  <ul>
                    <li><a href="https://www.airasia.com/my/en/about-us/ad-space.page" target="TRUE">Ad space</a></li>
                    <li><a href="https://www.airasiafoundation.com/" target="TRUE">AirAsia Foundation</a></li>
                    <li><a href="https://mycareer.airasia.com/gb/en" target="TRUE">Careers</a></li>
                    <li><a href="https://www.airasia.com/ir/" target="TRUE">Investor relations</a></li>
                    <li><a href="https://newsroom.airasia.com/" target="TRUE">Newsroom</a></li>
                    <li><a href="https://support.airasia.com/s/article/Sales-Office?language=en_GB" target="TRUE">Sales office</a></li>
                    <li><a href="https://www.airasia.com/promotions/" target="TRUE">Promotions</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </AboveFooterDiv>
        </div>
      </div>
      <UniversalFooter
        accessible
        background="greyLight"
        color="greyDark"
        data={dataUHF}
        isChinaDomain={PhoenixUtil.isChinaDomainName()}
        theme="AIRASIA_CLASSIC"
        viewport={props.device ? props.device : "desktop"}
      />
    </div>
  )
}


